import { ArrowDown, ArrowUp, Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

// Options of a «Menu a tendina» column: add, rename (stored values follow), reorder, remove (rows using it are emptied: warned).
export default function OptionsEditor({ opts, setOpts, usage, testid }) {
  const set = (i, p) => setOpts(opts.map((o, j) => (j === i ? { ...o, ...p } : o)));
  const move = (i, d) => { const x = [...opts]; [x[i], x[i + d]] = [x[i + d], x[i]]; setOpts(x); };
  return (
    <div className="space-y-1" data-testid={testid}>
      {opts.map((o, i) => {
        const used = o.orig ? usage?.[o.orig] || 0 : 0;
        return (
          <div key={o.id} className="flex items-center gap-1">
            <Input value={o.name} onChange={(e) => set(i, { name: e.target.value })} placeholder={`Opzione ${i + 1}`} className="h-7 flex-1 text-xs" data-testid={`${testid}-opt-${i}`} />
            {used > 0 && <span className="text-[10px] text-slate-400">{used} righe</span>}
            <Button variant="ghost" size="icon" className="h-7 w-7" disabled={i === 0} onClick={() => move(i, -1)} aria-label="Su"><ArrowUp size={12} /></Button>
            <Button variant="ghost" size="icon" className="h-7 w-7" disabled={i === opts.length - 1} onClick={() => move(i, 1)} aria-label="Giù"><ArrowDown size={12} /></Button>
            <Button variant="ghost" size="icon" className="h-7 w-7 text-red-600" onClick={() => setOpts(opts.filter((_, j) => j !== i))} aria-label="Rimuovi" title={used ? `${used} righe usano questa opzione: verranno svuotate` : "Rimuovi"} data-testid={`${testid}-remove-${i}`}><X size={12} /></Button>
          </div>);
      })}
      <Button variant="ghost" size="sm" className="h-7 px-2 text-xs" onClick={() => setOpts([...opts, { id: Math.random().toString(36).slice(2), orig: null, name: "" }])} data-testid={`${testid}-add`}><Plus size={12} className="mr-1" />Aggiungi opzione</Button>
    </div>);
}

export const toOpts = (list) => (list || []).map((o) => ({ id: Math.random().toString(36).slice(2), orig: o, name: o }));
export const lostOptions = (opts, original) => (original || []).filter((o) => !opts.some((x) => x.orig === o));
